interface Props {
    color: string;
    className?: string;
}

const WinnerSpan = ({ color, className }: Props) => {
    return (
        <svg
            className={className || ''}
            width="75"
            height="40"
            viewBox="0 0 75 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
        >
            <path
                d="M9.03028 19.9117L3.26582 20.5603C2.68186 20.626 2.36906 21.2811 2.68513 21.7765L6.43577 27.6552L2.73054 34.4537C2.42296 35.018 2.87826 35.6949 3.51692 35.6228L13.3824 34.5088L9.03028 31.5429V19.9117Z"
                fill="#F2C960"
            />
            <path d="M13.3825 34.4706L9.14722 31.5736L13.3825 31.0294V34.4706Z" fill="#F2C960" />
            <path
                d="M72.2114 11.6315L66.2635 12.331V24.4592L62.3528 28.1176L72.6502 26.8064C73.2533 26.7296 73.55 26.0312 73.1865 25.5439L68.8139 19.6805L72.9824 12.8331C73.3266 12.2678 72.8687 11.5542 72.2114 11.6315Z"
                fill="#F2C960"
            />
            <path d="M62.3528 28.1176L66.3234 24.4117L62.3528 24.9125V28.1176Z" fill="#F2C960" />
            <path
                d="M8.61792 30.3271V16.3278C8.61792 15.66 9.11543 15.0968 9.77814 15.0144L64.7167 8.18341C65.5022 8.08574 66.1972 8.69483 66.2035 9.48637L66.3145 23.5407C66.3198 24.2131 65.8201 24.7826 65.1527 24.8647L10.1031 31.6407C9.314 31.7379 8.61792 31.1222 8.61792 30.3271Z"
                fill={color}
                stroke="#F2C960"
                strokeWidth="0.529412"
            />
            <path
                d="M26.9835 18.0998L25.1055 24.3676L22.7848 24.6508L22.3885 21.2705L21.4059 24.8192L19.0852 25.1024L18.239 19.1671L20.2485 18.9219L20.4679 22.699L21.5938 18.7576L23.6286 18.5093L24.1087 22.2546L24.9739 18.3451L26.9835 18.0998ZM30.3603 17.6876L29.8444 23.7891L27.9778 24.017L28.4937 17.9155L30.3603 17.6876ZM37.2374 22.8868L35.3708 23.1146L33.6555 20.2876L33.3949 23.3558L31.5283 23.5836L32.0441 17.4821L33.9108 17.2542L35.6222 20.1329L35.8867 17.0131L37.7533 16.7852L37.2374 22.8868ZM44.6307 21.9843L42.7641 22.2122L41.0488 19.3852L40.7882 22.4534L38.9216 22.6812L39.4374 16.5797L41.3041 16.3518L43.0155 19.2304L43.28 16.1106L45.1466 15.8828L44.6307 21.9843ZM48.5697 16.9661L48.5101 17.7239L50.3599 17.4981L50.2339 18.9379L48.3841 19.1636L48.3083 20.0258L50.4104 19.7692L50.2835 21.2944L46.3149 21.7788L46.8307 15.6772L50.7994 15.1928L50.6718 16.7095L48.5697 16.9661ZM55.1184 14.6656C55.7574 14.5876 56.2551 14.6719 56.6115 14.9184C56.968 15.1648 57.1676 15.5271 57.2104 16.0052C57.223 16.1458 57.2231 16.2737 57.2108 16.389C57.1742 16.8028 57.0324 17.1812 56.7855 17.5241C56.538 17.8613 56.2017 18.1241 55.7766 18.3125L56.8727 20.4901L54.8211 20.7405L53.8808 18.6889L53.6944 20.878L51.8278 21.1059L52.3437 15.0043L55.1184 14.6656ZM53.9875 17.4136L54.7275 17.3232C54.9068 17.3013 55.0434 17.2449 55.1373 17.1538C55.2362 17.0564 55.2947 16.9185 55.3127 16.7401C55.3158 16.7113 55.3153 16.6744 55.3113 16.6294C55.3002 16.5056 55.2524 16.4148 55.1679 16.3569C55.0829 16.2933 54.9647 16.2708 54.8133 16.2893L54.0734 16.3796L53.9875 17.4136Z"
                fill="white"
            />
        </svg>
    );
};

export default WinnerSpan;
